module.exports = __webpack_public_path__ + "static/media/icon_error.29a544e6.svg";